var map = {
	"./de/detailWIRED.png": 92,
	"./en/detailWIRED.png": 93,
	"./es/detailWIRED.png": 94,
	"./fi/detailWIRED.png": 95,
	"./fr/detailWIRED.png": 96,
	"./hu/detailWIRED.png": 97,
	"./it/detailWIRED.png": 98,
	"./ro/detailWIRED.png": 99
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91;


//////////////////
// WEBPACK FOOTER
// ./src/Assets ^\.\/.*\/detailWIRED\.png$
// module id = 91
// module chunks = 0